function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBscLogo = function SvgBscLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 800 600"
    },
    xmlSpace: "preserve",
    viewBox: "169.1 68.9 461.4 461.4"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 399.8,
    cy: 299.6,
    r: 230.7,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f3ba2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.3 320.8 34.8 34.7-94.6 94.5-94.5-94.5 34.8-34.7 59.7 59.7 59.8-59.7zM396.5 261l35.3 35.3-35.3 35.3-35.2-35.2v-.1l6.2-6.2 3-3 26-26.1zm-119 .5 34.8 34.8-34.8 34.7-34.8-34.8 34.8-34.7zm238 0 34.8 34.8-34.8 34.7-34.8-34.8 34.8-34.7zm-119-119L491 237l-34.8 34.8-59.7-59.8-59.7 59.7L302 237l94.5-94.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#131415"
    },
    transform: "translate(3.333 3.333)"
  })));
};
export default SvgBscLogo;